<template>
  <div class='notification-wrapper'>
    <app-title title="Notifications"></app-title>
    <div v-if="notifications.length != 0" class="main-wrapper" style="height: auto;">
      <div
        v-for="(val, index) in notifications"
        :key="index"
        :class="val.is_done ? 'done' : 'not-done'" class="notice"
        @click="submitNotice(val.id, val.type, index)"
      >
        <div class="flex items-center">
          <div class="nazuna">
            <img v-if="val.is_done" src="../../assets/img/nazuna-smile.png">
            <img v-else src="../../assets/img/nazuna-question.png">
          </div>
          <p>
            {{ notificationMaster[val.type] }}
          </p>
        </div>
      </div>
    </div>
    <p v-else>
      {{lang[0]}}<br>{{lang[1]}}
    </p>
    <app-menu active="notification"></app-menu>
  </div>
</template>

<script>

import axios from 'axios';
import AppMenu from '../../components/Menu.vue'
import AppTitle from '../../components/Title.vue'
import notificationMaster from '../../masters/notificationMaster';
import notificationLangMaster from '../../masters/langMaster/notificationLangMaster';

export default {
  name: 'NotificationIndex',

  components: {
    AppMenu,
    AppTitle
  },

  data() {
    return {
      notifications: {},
      masterData: {},
      notificationMaster: notificationMaster[this.$store.state.account.lang],
      lang: notificationLangMaster[this.$store.state.account.lang],
    };
  },

  mounted() {
    this.masterData = notificationMaster;
    axios.get(`private/notifications/${this.$store.state.account.id}`).then((data) => {
      this.notifications = data.data.notifications.reverse();
    }).catch((err) => {
      console.log(err);
    });
  },

  methods: {
    submitNotice(id, type, index) {
      axios.put(`private/notifications/${id}`,{is_done: 1}
      ).then(data => {
        switch(type) {
          case 0 :
            this.$router.push(`/${this.$store.account.name}`)
            break
          default :
            this.$router.push(this.notifications[index].url)
        }
      }).catch(err => {
        console.log(err)
      })
    },
  },
};

</script>

<style scoped>

.notice {
  padding: 20px 10px;
  border-bottom: 1px solid #d1d1d1;
}

.notice p {
  line-height: 1em;
  margin-bottom: 0px!important;
}

.done {
  background: #fff;
}

.not-done {
  background: #ffdcd0;
}

.nazuna {
  width: 50px;
  height: 50px;
  margin-right: 20px;
  flex-shrink: 0;
}

.nazuna img {
  width: 100%;
}

.notification-wrapper {
  margin-bottom: 80px;
}

</style>
